export default "__VITE_ASSET__BUFdIm8x__"